<template>
    <DefaultLayout>
        <div class="container">
            <div class="row pt-2">
                <!-- Breadcrumbs -->
                <div class="col-8 p-0">
                    <nav aria-label="breadcrumb">
                    <ol class="py-1 my-2 breadcrumb align-middle">
                        <li class="breadcrumb-item">
                            <a href="/" class="text-primary fw-bold">
                                {{ $t('homepage') }}
                            </a>
                        </li>
                        <li class="breadcrumb-item">
                            <a class="text-secondary fw-bold">
                                Search
                            </a>
                        </li>
                    </ol>
                    </nav>
                </div>
                <div class="col-4 text-end"></div>
            </div>
            <div class="row">
                <div class="px-0 pb-4">
                    <div class="input-group">
                        <input
                            id="search_query_section"
                            v-model="searchQuery"
                            data-test="search_query_section"
                            type="text"
                            :placeholder="$t('network.searchnetworksandmedia')"
                            class="form-control shadow-sm"
                            @input="refreshResults"
                        />
                        <span id="basic-addon2" class="input-group-text shadow-sm"><i class="fa fa-search"></i></span>
                    </div>
                </div>
                <div v-if="searchQuery.length > 0" class="col-2 text-center">
                  <span ref="sent" role="button" :class="currentView == 'networks' ? 'text-primary underlined' : ''" class="tab ms-3" @click="currentView = 'networks'">
                    {{ $t('network.networks') }}
                    <span v-if="loaded">({{ myManagedNetworks.length + myNetworks.length + discoverNetworks.length }})</span>
                  </span>
                </div>
                <div v-if="searchQuery.length > 0" class="col-2 text-start">
                  <span ref="scheduled" role="button" :class="currentView == 'media' ? 'text-primary underlined' : ''" class="tab ms-3" @click="currentView = 'media'">
                    {{ $t('nav.media') }}
                    <span v-if="loaded">({{ pagination.full_result_count }})</span>
                  </span>
                </div>
                <div v-if="searchQuery.length > 0" class="col-8"></div><hr style="opacity: 0.5; height: 3px;">
                <div  v-if="searchQuery.length == 0" class="alert alert-info text-center">
                  <span class="fs-5">{{ $t('please-enter-a-search-term-to-see-results') }}</span>
                </div>
            </div>
            <div class="row">
                <div v-if="currentView == 'networks'">
                  <div v-if="loaded">
                    <div v-if="searchQuery.length > 0" class="row px-1">
                      <div class="d-lg-none d-xl-none"></div>
                      <NetworkList v-if="myManagedNetworks.length > 0" id="managed_networks" :title="$t('network.myManagedNetworks')" :networks="myManagedNetworks" :notifications=true />
                      <NetworkList v-if="myNetworks.length > 0" id="my_networks" :title="$t('network.myNetworks')" :networks="myNetworks" :notifications=true />
                      <NetworkList v-if="discoverNetworks.length > 0" id="discover_networks" :title="$t('network.discoverNetworks')" :networks="discoverNetworks" />
                    </div>
                    <div v-if="myManagedNetworks.length <= 0 && myNetworks.length <= 0 && discoverNetworks.length <= 0 && searchQuery.length > 0" class="row px-1">
                      <h4 class="text-center text-danger fw-semibold mt-1">
                        {{ $t('no-results-match-your-search-try-using-less-keywords-or-making-your-search-simpler') }}
                      </h4>
                    </div>
                  </div>
                  <div v-else class="row text-center mt-4">
                    <lottie-player
                      autoplay
                      loop
	                    speed="2.5"
                      src="/img/animations/custom_loader.json"
                      style="height: 130px;"
                      >
                    </lottie-player>
                  </div>
                </div>
                <div v-if="currentView == 'media'">
                  <div v-if="loaded">
                    <div v-if="filteredMedia.length > 0" class="row px-1">
                      <CardView :columns="[3]" :media="filteredMedia" displaySize="big" />
                    </div>
                    <div v-if="filteredMedia.length == 0 && searchQuery.length > 0" class="row px-1">
                      <h4 class="text-center text-danger fw-semibold mt-1">
                        {{ $t('no-results-match-your-search-try-using-less-keywords-or-making-your-search-simpler') }}
                      </h4>
                    </div>
                  </div>
                  <div v-else class="row text-center mt-4">
                    <lottie-player
                      autoplay
                      loop
	                    speed="2.5"
                      src="/img/animations/custom_loader.json"
                      style="height: 130px;"
                      >
                    </lottie-player>
                  </div>
                </div>
            </div>
        </div>
    </DefaultLayout>
</template>
<script>
import DefaultLayout from './layouts/default';
import NetworkList from '@/components/commons/Networks/NetworkList.vue';
import CardView from './networks/media/feed/views/CardView.vue';
import { debounce } from 'lodash';
import { mapState } from 'vuex';

export default {
  components: {
    CardView,
    DefaultLayout,
    NetworkList,
  },
  data() {
    return {
      loaded: false,
      searchQuery: sessionStorage.getItem('searchQuery') ?? '',
      currentView: 'networks',
      filteredMedia: [],
      pagination: []
    };
  },
  computed: {
  ...mapState('network', ['myManagedNetworks', 'myNetworks', 'discoverNetworks', 'trendingNetworks']),
  },
  watch: {
    async searchQuery() {
      this.loaded = false;
      try {
        await new Promise(resolve => {
          sessionStorage.setItem('searchQuery', this.searchQuery);
          this.$store.commit('feed/filter_text', this.searchQuery);
          resolve();
        });
        this.loaded = true;
      } catch (error) {
        console.error('An error occurred:', error);
        this.loaded = true;
      }
    },
  },
  created() {
    this.refreshResults = debounce(() => {
      this.loaded = false;
      this.$store.dispatch('network/loadNetworks', { search: this.searchQuery })
        .then(() => {
          if (this.searchQuery.length > 0) {
            this.$store.commit('feed/filter_text', this.searchQuery);
            this.$http
              .get('networks/feed', {
                params: this.getFeedRequest(),
              })
              .then(resp => {
                // store the full result count as returned by the server
                this.pagination.full_result_count = resp.data.full_result_count;
                let media = resp.data.results;
                this.filteredMedia = media;
                this.loaded = true;
              })
              .catch(error => {
                console.error('in catch reached end!', error);
                this.loaded = true;
              });
          } else {
            this.filteredMedia.splice(0);
            this.loaded = true;
          }
        })
        .catch(error => {
          console.error('An error occurred while loading networks:', error);
          this.loaded = true;
        });
    }, 600);
  },
  mounted() {
    this.loaded = false;
    this.$nextTick(async () => {
      if (this.searchQuery !== '') {
        try {
          await this.refreshResults();
        } catch (error) {
          console.error('An error occurred:', error);
          this.loaded = true;
        }
      } else {
        this.loaded = true;
      }
    });
  },
  methods: {
    async refreshResults() {
      await this.$store.dispatch('network/loadNetworks', { search: this.searchQuery });
    },
    scrollTo(id) {
      var element = document.getElementById(id);
      var headerOffset = 80;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    },
    getFeedRequest() {
      let request = {
        offset: 0,
        limit: 10000,
        network_id: null,
        unlisted: this.unlisted,
      };
      Object.assign(request, this.$store.getters['feed/getRequest']);
      return request;
    },
  },
};
</script>
<style scoped>
th {
  width: 150px;
  text-align: center;
  color: #5C6D80;
  font-weight: 600;
  font-size: 19px;
  line-height: 30px;
}
.tab {
  font-weight: 600;
  font-size: 20px;
}
.underlined {
  text-decoration-line: underline;
  text-decoration-thickness: 3px;
  text-underline-offset: 9px;
}
.tab:hover {
  color: #005f9a;
}
</style>